import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installAuthFetch } from "@/lib/authFetch";
import { initAnalytics } from "@/lib/analytics";
import { initNativeShell } from "@/lib/native";

// Install global fetch wrapper that attaches Bearer token and surfaces
// clearer network errors. Must run before App mounts.
installAuthFetch();
// Initialise PostHog (privacy-hardened; only approved events tracked).
initAnalytics();
// Initialise Capacitor-specific behaviours (status bar, Android back button).
// Safe no-op on the web build.
initNativeShell();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
